module.exports = __webpack_public_path__ + "media/images/talent/intro-bottom-sp-be494092376e786570ae2c0befb4f9a5.png";